import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import { applyTokens } from "../../../utilities/applyTokens.js";
import { createFocusStyle } from "../utils/createFocusStyle.js";
const BUTTON_CLASS = "AtlasRadioButton";
const INNER_CIRCLE_CLASS = `${BUTTON_CLASS}-innerCircle`;
const CIRCLE_CLASS = `${BUTTON_CLASS}-circle`;
const BORDER_COLOR_VAR = "--atlas-radio-border-color";
const applyState = (tokens, checked, state) => {
    const stateTokens = tokens.component.radioButton[checked][state];
    return {
        [BORDER_COLOR_VAR]: stateTokens.circle.borderColor.value,
        [` .${CIRCLE_CLASS}`]: applyTokens(stateTokens.circle),
        [` .${INNER_CIRCLE_CLASS}`]: applyTokens(stateTokens.innerCircle),
    };
};
const applyStates = (tokens, checked) => {
    return Object.assign(Object.assign({}, applyState(tokens, checked, "default")), { "&:hover": applyState(tokens, checked, "hover"), "&:active": applyState(tokens, checked, "active"), "&.Mui-disabled": applyState(tokens, checked, "disabled"), "&:has(.PrivateSwitchBase-input:focus)": {
            [` .${CIRCLE_CLASS}`]: createFocusStyle(tokens),
        } });
};
export function AtlasRadioButtonCircle({ children }) {
    return (_jsx(Stack, Object.assign({ className: CIRCLE_CLASS, alignItems: "center", justifyContent: "center", sx: ({ tokens }) => {
            const { circle } = tokens.component.radioButton;
            return Object.assign(Object.assign({}, applyTokens(circle)), { boxShadow: `inset 0 0 0 ${circle.borderWidth.value} var(${BORDER_COLOR_VAR})` });
        }, "aria-hidden": true }, { children: children })));
}
export function AtlasRadioButtonInnerCircle() {
    return (_jsx(Box, { className: INNER_CIRCLE_CLASS, sx: ({ tokens }) => (Object.assign({}, applyTokens(tokens.component.radioButton.innerCircle))) }));
}
const radioButton = (tokens) => {
    const { radioButton } = tokens.component;
    return {
        MuiRadio: {
            defaultProps: {
                disableRipple: true,
                icon: _jsx(AtlasRadioButtonCircle, {}),
                checkedIcon: (_jsx(AtlasRadioButtonCircle, { children: _jsx(AtlasRadioButtonInnerCircle, {}) })),
            },
            styleOverrides: {
                root: {
                    padding: 0,
                    " .PrivateSwitchBase-input": {
                        appearance: "none",
                        padding: 0,
                        border: 0,
                    },
                    " + .MuiFormControlLabel-label": applyTokens(radioButton.label),
                    "&:not(.Mui-checked)": applyStates(tokens, "unchecked"),
                    "&.Mui-checked": applyStates(tokens, "checked"),
                },
            },
        },
    };
};
export default radioButton;
//# sourceMappingURL=radioButton.js.map